import { TextField } from "@material-ui/core";
import React, { useState, useRef, useEffect } from "react";
import "../style.css";
const ToleranceDropdown = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  // const [taxableValue, setTaxableValue] = useState("");
  // const [taxRate, setTaxRate] = useState("");
  const dropdownRef = useRef(null);
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isValuesEmptyOrZero = () => {
    return (
      (!props.taxableValue || Number(props.taxableValue) === 0) &&
      (!props.taxRate || Number(props.taxRate) === 0)
    );
  };

  // return (
  //   <div
  //     style={{
  //       width: props.width ? props.width : "196px",
  //       position: "relative",
  //     }}
  //     ref={dropdownRef}
  //     className="option-for-select"
  //   >
  //     <div
  //       style={{
  //         border: "1px solid #b9b9b9",
  //         padding: "5px",
  //         borderRadius: "5px",
  //         cursor: "pointer",
  //       }}
  //       onClick={() => setIsOpen(!isOpen)}
  //     >
  //       {isValuesEmptyOrZero() ? (
  //         <div style={{ display: "flex" }}>
  //           <span
  //             style={{
  //               display: "flex",
  //               justifyContent: "flex-start",
  //               color: "#007bff",
  //             }}
  //           >
  //             Select Tolerance Limit
  //           </span>
  //           <div className="triangle-icon" style={{ top: "53%" }}></div>
  //         </div>
  //       ) : (
  //         <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
  //           {props.taxableValue && Number(props.taxableValue) !== 0 && (
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "space-between",
  //                 alignItems: "center",
  //                 fontWeight: "500",
  //               }}
  //             >
  //               Taxable Value
  //               <TextField
  //                 InputProps={{ readOnly: true }}
  //                 id="standard-size-small"
  //                 className="gstr2a2bnew-textfield"
  //                 value={props.taxableValue}
  //                 variant="outlined"
  //                 size="small"
  //               />
  //             </div>
  //           )}
  //           {props.taxRate && Number(props.taxRate) !== 0 && (
  //             <div
  //               style={{
  //                 display: "flex",
  //                 justifyContent: "space-between",
  //                 alignItems: "center",
  //                 fontWeight: "500",
  //               }}
  //             >
  //               Tax
  //               {/* <span style={valueStyle}>{taxRate}</span> */}
  //               <TextField
  //                 InputProps={{ readOnly: true }}
  //                 id="standard-size-small"
  //                 className="gstr2a2bnew-textfield"
  //                 value={props.taxRate}
  //                 variant="outlined"
  //                 size="small"
  //               />
  //             </div>
  //           )}
  //         </div>
  //       )}
  //     </div>
  //     {isOpen && (
  //       <div
  //         style={{
  //           border: "1px solid #ccc",
  //           marginTop: "5px",
  //           borderRadius: "15px",
  //           padding: "5px",
  //           backgroundColor: "#fff",
  //           boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
  //           position: "absolute",
  //           zIndex: "1",
  //           width: "196px",
  //         }}
  //       >
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "space-between",
  //             alignItems: "baseline",
  //           }}
  //         >
  //           <label style={{ width: "100px", fontSize: "12px" }}>
  //             Taxable Value
  //           </label>
  //           {/* <input
  //             type="number"
  //             value={taxableValue}
  //             onChange={(e) => setTaxableValue(e.target.value)}
  //             style={inputStyle}
  //           /> */}
  //           <TextField
  //             id="standard-size-small"
  //             className="gstr2a2bnew-textfield"
  //             value={props.taxableValue}
  //             size="small"
  //             autoComplete="off"
  //             onChange={(e) => {
  //               const { value } = e.target;
  //               // if (/^\d*$/.test(value)) {
  //               //   // Regular expression to allow only digits
  //               //   props.setTaxableValue(e.target.value);
  //               // }
  //               if (/^\d*$/.test(value) && value.length <= 20) {
  //                 props.setTaxableValue(value);
  //               }
  //             }}
  //             variant="outlined"
  //           />
  //         </div>
  //         <div
  //           style={{
  //             display: "flex",
  //             justifyContent: "space-between",
  //             alignItems: "baseline",
  //           }}
  //         >
  //           <label style={{ width: "100px", fontSize: "12px" }}>Tax</label>
  //           {/* <input
  //             type="number"
  //             value={taxRate}
  //             onChange={(e) => setTaxRate(e.target.value)}
  //             style={inputStyle}
  //           /> */}
  //           <TextField
  //             id="standard-size-small"
  //             className="gstr2a2bnew-textfield"
  //             size="small"
  //             value={props.taxRate}
  //             autoComplete="off"
  //             onChange={(e) => {
  //               const { value } = e.target;
  //               // if (/^\d*$/.test(value)) {
  //               //   // Regular expression to allow only digits
  //               //   props.setTaxRate(value);
  //               // }
  //               if (/^\d*$/.test(value) && value.length <= 20) {
  //                 props.setTaxRate(value);
  //               }
  //             }}
  //             variant="outlined"
  //           />
  //         </div>
  //       </div>
  //     )}
  //   </div>
  // );

  return (
      <div
        style={{
          width: props.width ? props.width : "196px",
          position: "relative",
          zIndex: "10",
        }}
        ref={dropdownRef}
      >
        {/* COLLAPSED HEADER */}
        <div
          style={{
            border: "1px solid #b9b9b9",
            padding: "5px",
            borderRadius: "5px",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontWeight: "500",
          }}
          onClick={() => setIsOpen(!isOpen)}
        >
          {isValuesEmptyOrZero() ? (
            <span style={{ color: "#007bff" }}>Select Tolerance Limit</span>
          ) : (
            <span>
              {props.taxableValue} | {props.taxRate}
            </span>
          )}
          <div
            className="triangle-icon"
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
            }}
          ></div>
        </div>
  
        {/* DROPDOWN PANEL */}
        {isOpen && (
          <div
            style={{
              border: "1px solid #ccc",
              marginTop: "5px",
              borderRadius: "10px",
              padding: "10px",
              backgroundColor: "#fff",
              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
              position: "absolute",
              width: "210px",
              zIndex: "1",
            }}
          >
            {/* Taxable Value */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <label style={{ fontSize: "12px" }}>Taxable Value</label>
              <TextField
                id="taxable-value"
                className="gstr2a2b-new-textfield"
                size="small"
                value={props.taxableValue}
                autoComplete="off"
                inputProps={{ maxLength: 5 }}
                onChange={(e) => {
                  const { value } = e.target;
                  if (/^\d*$/.test(value)) {
                    props.setTaxableValue(value);
                  }
                }}
                variant="outlined"
                placeholder="Enter value"
              />
            </div>
  
            {/* Tax */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <label style={{ fontSize: "12px" }}>Taxes</label>
              <TextField
                id="tax-rate"
                className="gstr2a2b-new-textfield"
                size="small"
                value={props.taxRate}
                autoComplete="off"
                inputProps={{ maxLength: 5 }}
                onChange={(e) => {
                  const { value } = e.target;
                  if (/^\d*$/.test(value)) {
                    props.setTaxRate(value);
                  }
                }}
                variant="outlined"
                placeholder="Enter tax"
              />
            </div>
          </div>
        )}
      </div>
    );
};

export default ToleranceDropdown;
